import { createAction, handleActions } from "redux-actions";

const SET = 'sound.SET';
const PLAY = 'sound.PLAY';
const STOP = 'sound.STOP';
const PAUSE = 'sound.PAUSE';
const CLEAR = 'sound.CLEAR';

const defaultState = {
  preload : 'auto',
  stopPlay: false,
};

const setSoundAction = createAction( SET, payload => payload );
const playSoundAction = createAction( PLAY );
const stopSoundAction = createAction( STOP );
const pauseSoundAction = createAction( PAUSE );
const clearSoundAction = createAction( CLEAR );

const sound = handleActions( {
  [SET] : ( state, action ) => {
    const { src } = action.payload;
    const modSrc = src?.replace("/static/audio/", "/static/audio/mp3/").replace('.ogg', '.mp3');
    console.log("***** sound: ", modSrc);
    return { 
      ...state, 
      ...action.payload,
      src: modSrc
    }
  },
  [PLAY] : state => {
    if (state.stopPlay) {
      return {
        ...state,
        stopPlay: !state.stopPlay
      }
    }
    return { ...state, isPlay: Date.now() }
  },
  [STOP]: (state) => ({ ...state, stopPlay: true }),
  [PAUSE] : state => ( { ...state, isPause : Date.now() } ),
  [CLEAR] : () => defaultState
}, defaultState );

export default sound;
export {
  setSoundAction,
  playSoundAction,
  stopSoundAction,
  pauseSoundAction,
  clearSoundAction
};
